<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>翻拍识别</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      当前待识别数量： {{waitingCnt}}张
    </layout-panel>
    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="客户名称"
                        prop="customer_name">
            <el-input placeholder="请输入客户名称"
                      clearable
                      v-model="search.customer_name" />
          </el-form-item>
          <el-form-item label="项目名称"
                        prop="project_name">
            <el-input placeholder="请输入项目名称"
                      clearable
                      v-model="search.project_name" />
          </el-form-item>
          <el-form-item label="批次名称"
                        prop="batch_name">
            <el-input placeholder="请输入批次名称"
                      clearable
                      v-model="search.batch_name" />
          </el-form-item>
          <el-form-item label="拍摄时间"
                        prop="created_at">
            <el-date-picker v-model="search.created_at"
                            style="width: 100%;"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            clearable
                            :default-time="['00:00:00', '23:59:59']"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态"
                        prop="result">
            <el-select v-model="search.result"
                       clearable>
              <el-option v-for="item in statusOpts"
                         :key="item.key"
                         :label="item.label"
                         :value="item.key" />
            </el-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button type="primary"
                     @click="onExportSearch">按搜索导出
          </el-button>
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <el-button type="success" size="mini" @click="setImageStatusBySearch(3)">按搜索结果置为非翻拍</el-button>
      </div>
      <div class="margin b15">
        <el-button type="primary" size="mini" @click="selectAll">全选</el-button>
        <el-button type="primary" size="mini" @click="unSelectAll">全不选</el-button>
        <el-button type="success" size="mini" @click="batchSetImageResult(3)" :disabled="!hasCheckOneImage">批量置为非翻拍</el-button>
        <el-button type="danger" size="mini" @click="batchSetImageResult(4)" :disabled="!hasCheckOneImage">批量置为确认翻拍</el-button>
      </div>
      <div>
        <div v-for="(image, index) of table" style="position: relative; display: inline-block">
          <el-image
            class="image-box"
            :src="image.url | ossThumbnail(140)"
            @click.stop="openImageDetailDialog(index)"
            fit="fill" />
          <el-checkbox v-model="image.checked"
                       style="position: absolute; left: -5px; top: 15px; transform: scale(1.3);" />
          <div :class="getDotClass(image)" />
        </div>
      </div>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>

    <image-detail-dialog ref="imageDialog"
                         @close="onRefresh"
                         :images="dialogImages"
                         @refresh="onRefresh">
    </image-detail-dialog>
  </div>
</template>

<script>
import dateTimePicker from '@core/mixins/dateTimePicker'
import ImageDetailDialog from '../components/ImageDetailDialog.vue'
import table from '@core/mixins/table-v3'
import ImageRecaptureDetectionMixins from '../order-image-recapture-detection.mixins'

export default {
  components: {ImageDetailDialog},
  mixins: [table, dateTimePicker, ImageRecaptureDetectionMixins],
  data () {
    return {
      search: {
        customerid: null,
        projectid: null,
        batchid: null,
        customer_name: null,
        project_name: null,
        batch_name: null,
        created_at: [],
        result: null,
      },
      waitingCnt: 0,
      searchFieldType: {
        result: Number
      },
      dialogImages: [
        {
          src: null,
          id: null
        }
      ]
    }
  },
  watch: {
    table (val) {
      this.dialogImages = val.map((image) => {
        return {
          src: image.url,
          id: image.id
        }
      })
    }
  },
  computed: {
    hasCheckOneImage () {
      return this.table.some((one) => one.checked)
    }
  },
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getOrderImageRecaptureDetectionImageTable', params).then((data) => {
        this.waitingCnt = data.data.waiting_cnt
        data.data.data.forEach((one) => {
          one.checked = false
        })
        return new Promise((resolve) => resolve(data))
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
      })
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportOrderImageRecaptureDetectionData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    onDelete (index, rows) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('deleteOrderImageRecaptureDetectionData', {id: rows[index].id}).then(() => {
          this.$message.success('删除成功')
          rows.splice(index, 1)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    getDotClass (row) {
      let res = ['image-status-dot']
      let stateColor
      switch (row.result) {
        case 2:
          stateColor = 'suspect'
          break
        case 3:
          stateColor = 'original'
          break
        case 4:
          stateColor = 'recaptured'
          break
      }
      if (stateColor) {
        res.push(stateColor)
      }
      return res
    },
    openImageDetailDialog (index) {
      this.$refs.imageDialog.open(index)
    },
    selectAll () {
      this.table.forEach((one) => {
        one.checked = true
      })
    },
    unSelectAll () {
      this.table.forEach((one) => {
        one.checked = false
      })
    },
    batchSetImageResult (result) {
      let imageIds = this.table.filter((one) => one.checked).map((one) => one.id)
      request.common('setOrderImageRecaptureDetectionImageStatus', {
        image_ids: imageIds,
        result
      }).then(() => {
        this.$message.success('设置成功')
        this.onSearch()
      })
    },
    setImageStatusBySearch (result) {
      request.common('setOrderImageRecaptureDetectionImageStatusBySearch', {
        ...this.search,
        target_result: result
      }).then(() => {
        this.$message.success('设置成功')
        this.onSearch()
      })
    }
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.image-box {
  width: 140px;
  height: 140px;
  margin: 15px;
  cursor: pointer;
}
.image-box /deep/ img {
  transition: all 0.6s;
}
.image-box /deep/ img:hover {
  transform: scale(1.5);
}
.image-status-dot {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 50%;
  background: #fff;
  &.suspect {
    background: #E6A23C;
  }
  &.original {
    background: #67C23A;
  }
  &.recaptured {
    background: #F56C6C;
  }
}
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/order-image-recapture-detection/pages/OrderImageRecaptureDetectionImageTable.vue